import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { DashBoard } from "../pages/dashboard";
import { ForgotPassword } from "../pages/user/forgotPassword";
import { ResetPassword } from "../pages/user/forgotPassword/resetPassword";
import { Signin } from "../pages/user/signin";
import { AdminSignin } from "../pages/user/signin/adminSignin";
import { Signup } from "../pages/user/signup";
import { AdminDashboardLayout } from "../pages/dashboard/adminDashboardLayout";
import Page404 from "../pages/404Page";
import { CONSOLE_MODE } from "../api/constants/constants";
import { PurchaseRedirect } from "../components/companyRegistration/subscriptions/stripePayment/redirectPage";
import PurchaseReview from "../components/companyRegistration/subscriptions/stripePayment/confirmPayment";
import PaymentFailed from "../components/companyRegistration/subscriptions/stripePayment/paymentFailed";
// import { Authenticator } from "../pages/user/Authenticator";

export const RouteList = ()=>{
if(CONSOLE_MODE.mode === 'production'){
    console.log = ()=>{}
}

    return(
        <>
        <Routes>
            <Route  path=""  element={<Navigate replace to='/signin'/>} />
            <Route  path="/signin"  element={<Signin/>} />
            <Route  path="/signup"  element={<Signup/>} />
            <Route  path="/forgot-password"  element={<ForgotPassword/>} />
            <Route  path="/admin-change-password"  element={<ForgotPassword/>} />
            <Route  path="/reset-password"  element={<ResetPassword/>} />
            <Route  path="/dashboard"  element={<DashBoard/>} />
            <Route  path="/employee-onboarding"  element={<DashBoard/>} />
            <Route  path="/licence"  element={<DashBoard/>} />
            <Route  path="/user-profile"  element={<DashBoard/>} />
            <Route  path="/company-profile"  element={<DashBoard/>} />
            <Route  path="/representative-profile"  element={<DashBoard/>} />
            <Route exact path="/dashboard/redirect-url"  element={<PurchaseRedirect/>} />
            <Route exact path="/dashboard/purchasereview"  element={<PurchaseReview/>} />
            <Route exact path="/dashboard/paymentfailed"  element={<PaymentFailed/>} />
            <Route  path="/admin-dashboard"  element={<AdminDashboardLayout />} />
            <Route  path="/admin-signin"  element={<AdminSignin/>} />
            <Route  path="/profile"  element={<DashBoard/>} />
            <Route  path="/user-onboard"  element={<DashBoard/>} />
            {/* <Route  path="/welcome"  element={<Authenticator/>} /> */}
            <Route  path="*"  element={<Page404/>} />
        </Routes>
        </>
    )
}